import React from 'react';
import { Box, Flex, Heading, Button } from '@marvelapp/ui';
import { downscaledAsset } from '../../../utils/handoff/assets';
import AssetPreview from '../AssetPreview';
export var ASSET_WIDTH = 54;
export default function ImageFill(_a) {
    var url = _a.url;
    return (React.createElement(Flex, { alignItems: "center" },
        React.createElement(Box, { width: 1 / 4 },
            React.createElement(AssetPreview, { url: downscaledAsset(url, ASSET_WIDTH) })),
        React.createElement(Flex, { alignItems: "center", justifyContent: "space-between", paddingLeft: 3, width: 3 / 4 },
            React.createElement(Heading, { fontSize: 12, fontWeight: 500 }, "Image Fill"),
            React.createElement(Button, { as: "a", download: true, hover: "blue", href: url, kind: "ghost" }, "Download"))));
}
